export function formatActivationCode(activationCode) {
  if (activationCode && activationCode.length > 5) {
    return activationCode.slice(0,4)+"-"+activationCode.slice(4,7)+"-"+activationCode.slice(7,11)
  }
};
